t = require('views/internal/teacup-with-helpers')('member_billing_org_link_list')

module.exports = ->
  t.div '.u-gutter.markeddown', ->

    t.div { style: 'max-width: 450px;' }, ->
      t.h3 ->
        t.format 'looking-for-your-organization-s-billing-page'

      t.ul '.js-org-link-list'

      t.p '.quiet', ->
        t.format 'this-is-your-personal-billing-page-you-can-manage-the-billing-for-your-business-class-organizations-on-the-above-pages'

    t.hr()




// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_billing_org_link_list.coffee